export default __webpack_public_path__ + "static/media/planet_pressed.fdbd1190.png";